<template>
  <v-container fluid>
    <v-col>
      <v-row>
        <financial-statistics/>
      </v-row>
      <v-row>
        <invoicing class="mt-n5"/>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
  export default {
    name: 'Statistics',
    components: {
      FinancialStatistics: () => import ('@/components/statistics/FinancialStatistics.vue'),
      Invoicing: () => import ('../../components/financial/invoicing/Invoicing.vue'),
    },
  }
</script>

<style lang="scss" scoped>

</style>